<!--
 * @Author: your name
 * @Date: 2020-09-28 19:29:53
 * @LastEditTime: 2020-11-25 16:32:03
 * @LastEditors: Zed
 * @Description: In User Settings Edit
 * @FilePath: \bidding-oa-web\src\views\components\resultTable.vue
-->
<template>
  <div>
    <!-- <el-table :data="list" :show-header="!hideHeader" style="width: 100%" @row-click="onInfo"> -->
    <el-table :data="list" :show-header="!hideHeader" style="width: 100%">
      <el-table-column label="项目名称" prop="projectName" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <p class="sucess" @click="onInfo(scope.row)">{{ scope.row.projectName }}</p>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="发布日期" prop="createTime" width="180">
        <template slot-scope="scope">
          <div class="release-time">{{ scope.row.createTime }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column :show-overflow-tooltip="true" label="操作"  width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">查看原公告</el-button>
        </template>
      </el-table-column> -->
      <div slot="empty" class="empty">
      <el-empty description="暂无数据" />
    </div>
    </el-table>

    <el-dialog title="查看原公告" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <el-table :data="detailList" :show-header="!hideHeader" style="width: 100%">
        <el-table-column label="项目名称" prop="projectName" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <p class="sucess" @click="onInfo(scope.row)">{{ scope.row.projectName }}</p>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="发布日期" prop="createTime" width="180">
          <template slot-scope="scope">
            <div class="release-time">{{ scope.row.createTime }}</div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="total,  prev, pager, next, jumper" :current-page="query.current" :page-sizes="[10, 20, 30, 100]"
        :page-size="query.size" :total="total" />

    </el-dialog>

  </div>
</template>

<script>
import announcement from "@/api/announcement/announcement"
export default {
  props: {
    list: Array,
    hideHeader: Boolean
  },
  data() {
    return {
      dialogVisible: false,
      detailList: [],
      total: '',
      query: {
        current: 1,
        size: 4,
        projectId: ''
      },
    }
  },
  methods: {
    onInfo(row) {
      console.log(row);
      sessionStorage.setItem("projectId", row.projectId);
      sessionStorage.setItem("bulletinId", row.id);
      this.$router.push({
        path: "/purchase/info",
        query: {
          noticeId: row.noticeId,
          projectId: row.projectId,
          type: 4
        }
      })
      // window.open(row.projectResultBulletinUrl)
    },
    handleClick(row) {
      console.log(row)
      this.query.projectId = row.projectId
      this.queryResultBulletinList(row.projectName)
    },
    handleClose() {
      this.dialogVisible = false;
    },

    queryResultBulletinList(projectName) {
      announcement.queryOriginalResultBulletinList(this.query).then(
        res => {
          console.log("结果公告", res);
          if (res.code === 200) {
            if (res.data.records.length > 0) {
              this.dialogVisible = true
              console.log(res.data);
              this.detailList = res.data.records;
              for (let i in this.detailList) {
                this.detailList[i].projectName = projectName
              }

              this.total = res.data.total;
            } else {
              this.$message.warning("暂无结果更新公告")
            }

          }
        }
      )
    },
    handleSizeChange(val) {
      this.query.size = val;
      this.queryResultBulletinList()
    },
    handleCurrentChange(val) {
      this.query.current = val;
      this.queryResultBulletinList()
    }
  },
  created() {
    // console.log(this.list);
  },
}
</script>

<style lang="less" scoped>
.release-time {
  color: #999999;
}

.sucess {
  color: #131313;
  text-decoration: none;
  cursor: pointer;
  margin: 0
}

.el-pagination {
  text-align: center;
  margin-top: 20px;
}

/deep/.el-button--small {
  padding: 0
}
</style>